import RestConfiguration from 'core/rest/config.js';

export const getData = () => ({
  type: 'GET_DATA',
  request: {
    METHOD: RestConfiguration.FIELDS_DATA.type,
    ENDPOINT: RestConfiguration.FIELDS_DATA.url,
    PAYLOAD: null,
    HEADERS: null,
  },
});

export const updatePopup = () => ({
  type: 'UPDATE_POPUP',
});
export const closePopup = (popupdata) => ({
  type: 'CLOSE_POPUP',
  popupdata,
});
